
"use strict";


var GLOBALS = GLOBALS || {};

// Do this immediately

(function($) {

    // FastClick.js

    $(function() {
        FastClick.attach(document.body);
    });


    // Load / Unload animations

    setTimeout(function(){
        $('body, .loader').addClass('load');
    },0);


    // Use smooth transitions between pages on certain links

    $(document).keydown(function(event){
        if(event.which=="17") {
            GLOBALS.cntrlIsPressed = true;
        }
    });

    $(document).keyup(function(event){
        if(event.which=="17") {
            GLOBALS.cntrlIsPressed = false;
        }
    });


    $('#mainnav a, .grid a, .list a, a.btn, .content a')
        .not('.dropdown-toggle, .lightbox, .anchor, [role="tab"], [href^="#"], [target]')
        .on('click', function (e) {
            if (!GLOBALS.cntrlIsPressed) {
                $('body').addClass('unload');
            }
        });


    // Below are fixes for "back-forward cache" issues:
    // http://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
    // https://developer.mozilla.org/en-US/Firefox/Releases/1.5/Using_Firefox_1.5_caching

    // Fixes Firefox "back" button issue
    $(window).on('unload', function() {});

    // Fixes iPhone "back" button issue
    $(window).bind("pageshow", function(event) {
        if (event.originalEvent.persisted) {
            window.location.reload()
        }
    });


    // Now this condition is never met, because the page has been split into two.
    // Leaving here for reference.
/*
    if ($('body').hasClass('page-template-globe-invest')) {

        // JS media queries via enquire.js

        enquire.register("screen and (max-width: 1280px)", {

            // OPTIONAL
            // If supplied, triggered when a media query matches.
            match : function() {
                GLOBALS.collapseTeam = false;

                resetTeam();
            },

            // OPTIONAL
            // If supplied, triggered when the media query transitions
            // *from a matched state to an unmatched state*.
            unmatch : function() {
                GLOBALS.collapseTeam = true;

                resetTeam();

                var teamListBox = $('section.meet-the-team .black-block');
                teamListBox.css('min-height', $('section.intro').height());

                // Reset slideToggle effects
                teamListBox.find('.long-t').css('display','');
                teamListBox.find('.read-more').removeClass('open');
            },

            // OPTIONAL
            // If supplied, triggered once, when the handler is registered.
            setup : function() {
                GLOBALS.collapseTeam = true;

                var parentListContainer = $('section.meet-the-team');
                parentListContainer.find('.fj-previous').text('Previous');
                parentListContainer.find('.fj-next').text('Next');
            }

        });

    }*/

    if ($('body').hasClass('page-template-meet-the-team')) {

        // JS media queries via enquire.js

        enquire.register("screen and (max-width: 1280px)", {

            // OPTIONAL
            // If supplied, triggered when a media query matches.
            match : function() {
                resetTeams();
            },

            // OPTIONAL
            // If supplied, triggered when the media query transitions
            // *from a matched state to an unmatched state*.
            unmatch : function() {
                resetTeams();

                var teamListBoxes = $('section.meet-the-team .black-block');

                teamListBoxes.each(function(index){

                    console.log(index);

                    var teamListBox = $(this);

                    // Reset slideToggle effects
                    teamListBox.find('.long-t').css('display','');
                    teamListBox.find('.read-more').removeClass('open');

                    var people = teamListBox.find('li');
                    displayPeoplePage(teamListBox, people);
                });

                
            },

            // OPTIONAL
            // If supplied, triggered once, when the handler is registered.
            setup : function() {
                var parentListContainer = $('section.meet-the-team');
                parentListContainer.find('.fj-previous').text('Previous');
                parentListContainer.find('.fj-next').text('Next');
            }

        });

    }

    function resetTeams() {

        var parentListContainer = $('section.meet-the-team');
        var parentList = parentListContainer.find('ul');

        parentList.removeClass('spotlight');
        parentList.find('> li').removeClass('expand').show();

        // $('.row.globe-invest').removeClass('show-team');
        // $('a.meet-the-team').find('h2').text('Meet the team');


    }

})(jQuery);


function displayPeoplePage(teamListBox, people) {

    // Perhaps not required?
    var prev = teamListBox.find('.fj-previous');
    var next = teamListBox.find('.fj-next');


    // Show only range of current page
    var curPage = teamListBox.data('page');

    // Clamp page value
    curPage = Math.max(0, Math.min(curPage, Math.floor(people.length / 6)));
    teamListBox.data('page', curPage);

    // Make nav buttons inactive at ends of range
    prev.add(next).removeClass('inactive');
    if (curPage == 0) {
        prev.addClass('inactive');
    }
    if (curPage == Math.floor(people.length / 6)) {
        next.addClass('inactive');
    }

    people.hide();
    people.slice((curPage * 6), (( curPage + 1 ) * 6)).show();
}


// On document ready

jQuery(document).ready(function($) {

    var _window = $(window);
    var _body = $('body');
    var backgroundImage = $('#page-background');

    var enableToTopButton = true;


    /**
     * "To top" Button
     */

    var toTopElement = $('#to-top'); // The ToTop element

    if (!enableToTopButton) {
        _body.remove(toTopElement);
    }

    toTopElement.on('click', function () { // When ToTop button is clicked, scroll up
        $('html, body').animate({
            scrollTop: 0
        });
    });


    /**
     * "To top" Button
     */

    // Use Masonry script when images are loaded
    $('.item').imagesLoaded({background: true}).done(function () {
        $(this).addClass('loaded');
    });


    /**
     * Scroll event throttling with rAF
     */

    var tickQueued = false;

    var showingScroll = false;

    var parallaxSpeed = 0.15;   // Parallax background script, use the ".parallax" class.
    var parallaxElements = $('.parallax');

    var $animation_elements = $('.fly-in'); // Elements that fly-in the window after they're visible on screen

    tick();

    _window.on('scroll resize', function () {
        tryTick();
    });

    function tryTick() {

        if (tickQueued) {
            return;
        }

        requestAnimationFrame(tick);
        tickQueued = true;
    }

    function tick() {
        tickQueued = false;

        positionToTopEl();
        // inView();
        // parallax();
    }

    function positionToTopEl() {
        var showScroll = _window.scrollTop() > 100;

        // If showScroll has changed since last check
        if (showScroll != showingScroll) {

            if (showScroll) {
                toTopElement.addClass('show');
            }
            else {
                toTopElement.removeClass('show');
            }
        }
        showingScroll = showScroll;
    }

    function inView() { // Function when element is in view

        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function () {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            //check to see if this current container is within viewport
            if ((element_bottom_position >= window_top_position) &&
                (element_top_position <= window_bottom_position)) {
                $element.addClass('in-view');
            } else {
                $element.removeClass('in-view');
            }
        });
    }

    function parallax() {

        parallaxElements.each(function () {
            var el = $(this);
            var yOffset = $(window).scrollTop();
            var parallaxOffset = yOffset * parallaxSpeed;
            parallaxOffset = +parallaxOffset.toFixed(2);

            if (el.hasClass('fs')) {
                el.css('transform', 'translate3d(-50%,-' + (50 - parallaxOffset * .15) + '%,0)');
            } else {
                el.css('transform', 'translate3d(0,' + parallaxOffset + 'px,0)');
            }
        });
    }



    // Page-specific

    if (_body.hasClass('page-template-meet-the-team') || _body.hasClass('page-template-about-globe-invest')) {
        backgroundImage.addClass('animated');
    }


    // Now this condition is never met, because the page has been split into two.
    // Leaving here for reference.
/*
    if (_body.hasClass('page-template-globe-invest')) {

        backgroundImage.addClass('animated');

        var teamBox = $('.row.globe-invest');
        var teamListBox = $('section.meet-the-team .black-block');

        var prev = teamListBox.find('.fj-previous');
        var next = teamListBox.find('.fj-next');
        var people = teamListBox.find('li');

        prev.click(function(e) {
            e.preventDefault();
            teamListBox.data().page--;
            displayPeoplePage(teamListBox, people);
        });

        next.click(function(e) {
            e.preventDefault();
            teamListBox.data().page++;
            displayPeoplePage(teamListBox, people);
        });


        $('a.meet-the-team').on('click', function(e) {
            e.preventDefault();
            teamBox.toggleClass('show-team');

            var newText = teamBox.hasClass('show-team') ? 'Close' : 'Meet the team';
            $(this).find('h2').text(newText);

            if (teamBox.hasClass('show-team')) {

                // Set up pagination

                teamListBox.data('page', 0);

                if (people.length > 6) {

                    // Show pagination buttons
                    prev.add(next).show();

                    displayPeoplePage(teamListBox, people);

                }
            }
        });



        teamListBox.css('min-height', $('section.intro').height());

        teamListBox.on('click', '.person', function(e) {

            e.preventDefault();

            var bio = $(this).closest('li');
            var parentList = bio.closest('ul');

            if (GLOBALS.collapseTeam) {
                if (parentList.hasClass('spotlight')) {

                    parentList.removeClass('spotlight');
                    bio.siblings().addBack().removeClass('expand');
                }
                else {
                    parentList.addClass('spotlight');

                    bio.siblings().removeClass('expand');
                    bio.addClass('expand');
                }
            }
            else {
                // bio.toggleClass('expand');
                // bio.find('.long-t').slideToggle();
            }

        });

        teamListBox.on('click', '.read-more', function(e) {

            e.preventDefault();

            var bio = $(this).closest('li');

            if (!GLOBALS.collapseTeam) {
                bio.find('.long-t').slideToggle();
                $(this).toggleClass('open');


            }

        });

        $('.fj-close').click(function(e){
            e.preventDefault();

            var teamList = teamListBox.find('ul');
            teamList.removeClass('spotlight');
            teamList.find('li').removeClass('expand');

        });
    }
    */
    if (_body.hasClass('page-template-meet-the-team')) {

        var teamBox = $('.row.globe-invest');
        var teamListBoxes = $('section.meet-the-team .black-block');

        teamListBoxes.each(function(){
            var teamListBox = $(this);

            var prev = teamListBox.find('.fj-previous');
            var next = teamListBox.find('.fj-next');
            var close = teamListBox.find('.fj-close');
            var people = teamListBox.find('li');

            prev.click(function(e) {
                e.preventDefault();
                teamListBox.data().page--;
                displayPeoplePage(teamListBox, people);
            });

            next.click(function(e) {
                e.preventDefault();
                teamListBox.data().page++;
                displayPeoplePage(teamListBox, people);
            });


            // Set up pagination

            teamListBox.data('page', 0);

            if (people.length > 6) {

                // Show pagination buttons
                prev.add(next).show();

                displayPeoplePage(teamListBox, people);

            }


            teamListBox.on('click', '.person', function(e) {

                e.preventDefault();

                var bio = $(this).closest('li');
                var parentList = bio.closest('ul');


                    if (parentList.hasClass('spotlight')) {

                        parentList.removeClass('spotlight');
                        bio.siblings().addBack().removeClass('expand');
                    }
                    else {
                        parentList.addClass('spotlight');

                        bio.siblings().removeClass('expand');
                        bio.addClass('expand');
                    }

            });

            teamListBox.on('click', '.read-more', function(e) {

                e.preventDefault();

                var bio = $(this).closest('li');

                bio.find('.long-t').slideToggle();
                $(this).toggleClass('open');

            });

            close.click(function(e){
                e.preventDefault();
    
                var teamList = teamListBox.find('ul');
                teamList.removeClass('spotlight');
                teamList.find('li').removeClass('expand');
    
            });
        });

        
        
    }


    if (_body.hasClass('films')) {
        // backgroundImage.addClass('animated');
    }


    if (_body.hasClass('contact')) {

        // Add placeholder capability, for the ~1% that don't have it natively
        $('input, textarea').placeholder();
    }


    var grid = $('.grid');
    function equalHeights(){
        var maxHeight = 0;

        var items = grid.find('.item');
        items.each(function(){
            var item = $(this);
            item.css('height', 'auto');
            maxHeight = Math.max(item.height(), maxHeight);
        });

        items.css('height', maxHeight);
    }

    if (grid.length) {
        $(window).smartresize(equalHeights);
        equalHeights();

        // Sometimes, despite there being enough information to calculate item height once the DOm is ready,
        // the image heights are not taken into account.
        grid.imagesLoaded().done(function () {
            equalHeights();
        });
    }



    /**
     * SVG test and fallback
     */

    function supportsSvg() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) == 'http://www.w3.org/2000/svg';
    }

    if (!supportsSvg()) {
        $('html').addClass('no-svg');
    }

});
